/* eslint-disable no-console, import/prefer-default-export */
import { removeAllErrors, validate } from '../../utils/form-validation-utils';
import SitePopup from '../site-popup';

let modalId = '';
let modalDiv = null;
let modal = null;
let promoDiscountCode = '';

const getPromoPopupHtml = (code) => {
  const url = `/api/GetPromoPopupHtml?code=${code}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};

const isEmailSubmitted = (email) => {
  const url = `/api/PostPop200?email=${email}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const saveDiscountCode = (code) => {
  const url = `/api/SaveDiscountCode?code=${code}`;
  fetch(url, {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
  });
};

const onSubmitClick = (event) => {
  const { gatorApi } = window;
  const form = modalDiv.querySelector('.promo-form');
  const contentDiv = modalDiv.querySelector('.modal-content');
  const altContentDiv = modalDiv.querySelector('.modal-alternate-content');

  event.preventDefault();
  removeAllErrors(form);
  if (!validate(form)) {
    modal.updateHeight();
    return;
  }
  const email = modalDiv.querySelector('#promo-email').value;
  // Log with gator.io
  if (gatorApi) {
    gatorApi.log('Pop 200', '', '', '', email, '');
  }
  // Submit form
  isEmailSubmitted(email)
    .then((data) => {
      if (data.isOk) {
        saveDiscountCode(promoDiscountCode);
        contentDiv.classList.add('hidden');
        altContentDiv.classList.remove('hidden');
        modal.updateHeight();
      }
    });
};

const initModal = (modalHtml) => {
  // Append html to the end of the DOM
  const body = document.querySelector('body');
  const div = document.createElement('div');
  div.innerHTML = modalHtml.trim();
  body.appendChild(div.firstChild);
  // Define div references
  modalDiv = document.getElementById(modalId);
  const submitBtn = modalDiv.querySelector('.submit-btn');
  modal = new SitePopup({
    callbacks: {
      onOpen: () => {
        submitBtn.addEventListener('click', onSubmitClick);
      },
    },
    id: modalId,
  });
  modal.open();
};

const getPromoPopup = (code) => {
  promoDiscountCode = code;
  modalId = `${code}-modal`;
  getPromoPopupHtml(code)
    .then((data) => {
      if (data !== '~error~') {
        initModal(data);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export {
  getPromoPopup,
};
/* eslint-enable no-console, import/prefer-default-export */
